import * as React from 'react';

import { ErrorLogComponent } from '@cian/error-log-component';
import { ILogger } from '@cian/logger/shared';

import { GalleryControlsContainer } from './controls/container';
import { FotoramaContainer } from './fotorama/container';
import { PromoContainer } from './promo/container';

import * as styles from './index.css';
import { CountrysidePromoLabelContainer } from '../CountrysidePromotionsLabel/container';

export interface IOfferGalleryProps {
  reactErrorLogger: ILogger;
}

export class OfferGallery extends React.Component<IOfferGalleryProps, {}> {
  public render() {
    return (
      <div className={styles['photo_gallery_container']} id="photos">
        <ErrorLogComponent logger={this.props.reactErrorLogger}>
          <FotoramaContainer />
        </ErrorLogComponent>
        <GalleryControlsContainer />
        <PromoContainer />
        <CountrysidePromoLabelContainer />
      </div>
    );
  }
}
